export default __webpack_public_path__ + "static/media/clickMe.efe722c7.gif";